// eslint-disable-next-line no-restricted-imports
import { ButlerRuleDataModel } from 'app/gamma/src/types/models';
// eslint-disable-next-line no-restricted-imports
import { ButlerRuleDataResponse } from 'app/gamma/src/types/responses';
import genericNormalizer from './generic';

// eslint-disable-next-line @trello/no-module-logic
export const normalizeButlerRule = genericNormalizer<
  ButlerRuleDataResponse,
  ButlerRuleDataModel
>(({ from }) => ({
  url: from('url'),
  text: from('text'),
  id: from('id'),
}));
